export default __webpack_public_path__ + "static/media/tuto_kingdom_2_1x.8fc69dbc.webp";